import { Button, ButtonGroup, Modal } from '@veneer/core';

interface ModalCheckoutCancelProps {
  showCancelModal: boolean;
  onCancelCloseTapped: (state: boolean) => void;
  onCancelBackTapped: (state: boolean) => void;
  onCancelConfirmTapped: () => void;
  device: string;
  category: string;
  expirationDate: string;
}

const ModalCheckoutCancel = (props: ModalCheckoutCancelProps) => {
  const categoryDescription: {
    [index: string]: {
      [index: string]: JSX.Element;
    };
  } = {
    android: {
      photobook: (
        <p>If you exit, we won’t be able to send you the photobook and you will not be able to create a new one.</p>
      ),
      canvas: <p>If you exit, we won’t be able to send you the canvas and you will not be able to create a new one.</p>,
    },
    ios: {
      photobook: (
        <p>
          You’re almost done! We’ve saved your project, please come back within [{props.expirationDate}] to complete it
          before your photos are removed.
        </p>
      ),
      canvas: (
        <p>
          You’re almost done! We’ve saved your project, please come back within [{props.expirationDate}] to complete it
          before your photos are removed.
        </p>
      ),
    },
  };
  const deviceButtons: {
    [index: string]: JSX.Element;
  } = {
    android: (
      <ButtonGroup>
        <Button onClick={() => props.onCancelBackTapped(false)}>No, go back</Button>
        <Button appearance="secondary" onClick={props.onCancelConfirmTapped}>
          Yes, exit
        </Button>
      </ButtonGroup>
    ),
    ios: (
      <ButtonGroup>
        <Button onClick={props.onCancelConfirmTapped}>Exit to Home screen</Button>
      </ButtonGroup>
    ),
  };
  return (
    <Modal
      id="cancel-modal"
      closeButton
      onClose={() => props.onCancelCloseTapped(false)}
      show={props.showCancelModal}
      title="Are you sure?"
      footer={deviceButtons[props.device]}
    >
      {categoryDescription[props.device][props.category]}
    </Modal>
  );
};

export default ModalCheckoutCancel;
